import React, { useState } from 'react';

const motivos = [
  { value: 'mudanca_endereco', label: 'Mudança de endereço' },
  { value: 'insatisfacao_servico', label: 'Insatisfação com o serviço' },
  { value: 'preco_alto', label: 'Preço alto' },
  { value: 'concorrencia', label: 'Concorrência' },
  { value: 'inadimplencia', label: 'Inadimplência' },
  { value: 'solicitacao_cliente', label: 'Solicitação do cliente' },
  { value: 'falecimento', label: 'Falecimento' },
  { value: 'outros', label: 'Outros' }
];

const CancelarContratoModal = ({ open, onClose, onSubmit, initial = {} }) => {
  const [motivoCancelamento, setMotivoCancelamento] = useState(initial.motivoCancelamento || 'solicitacao_cliente');
  const [detalhesMotivo, setDetalhesMotivo] = useState(initial.detalhesMotivo || '');
  const [feedbackCliente, setFeedbackCliente] = useState(initial.feedbackCliente || '');
  const [tentativasRetencao, setTentativasRetencao] = useState(initial.tentativasRetencao || '');
  const [observacoes, setObservacoes] = useState(initial.observacoes || '');
  const [submitting, setSubmitting] = useState(false);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const payload = {
        motivoCancelamento: motivoCancelamento,
        detalhesMotivo: detalhesMotivo || undefined,
        feedbackCliente: feedbackCliente || undefined,
        tentativasRetencao: tentativasRetencao || undefined,
        observacoes: observacoes || undefined
      };

      await onSubmit(payload);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-dark-card rounded-lg p-6 max-w-[90vw] w-[min(90vw,720px)] mx-4">
        <h3 className="text-lg font-bold mb-3">Cancelar Contrato</h3>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <label className="block text-sm font-medium mb-1">Motivo do cancelamento *</label>
            <select
              required
              value={motivoCancelamento}
              onChange={(e) => setMotivoCancelamento(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg dark:bg-gray-800"
            >
              {motivos.map((m) => (
                <option key={m.value} value={m.value}>{m.label}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Detalhes do motivo (opcional)</label>
            <textarea
              value={detalhesMotivo}
              onChange={(e) => setDetalhesMotivo(e.target.value)}
              rows={3}
              className="w-full px-3 py-2 border rounded-lg dark:bg-gray-800"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Feedback do cliente (opcional)</label>
            <textarea
              value={feedbackCliente}
              onChange={(e) => setFeedbackCliente(e.target.value)}
              rows={2}
              className="w-full px-3 py-2 border rounded-lg dark:bg-gray-800"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Tentativas de retenção (opcional)</label>
            <textarea
              value={tentativasRetencao}
              onChange={(e) => setTentativasRetencao(e.target.value)}
              rows={2}
              className="w-full px-3 py-2 border rounded-lg dark:bg-gray-800"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Observações (opcional)</label>
            <textarea
              value={observacoes}
              onChange={(e) => setObservacoes(e.target.value)}
              rows={2}
              className="w-full px-3 py-2 border rounded-lg dark:bg-gray-800"
            />
          </div>

          <div className="flex gap-2 justify-end pt-2">
            <button type="button" onClick={onClose} className="px-4 py-2 border rounded-lg">Cancelar</button>
            <button type="submit" disabled={submitting} className="px-4 py-2 bg-red-600 text-white rounded-lg">{submitting ? 'Enviando...' : 'Confirmar Cancelamento'}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CancelarContratoModal;
